import dataCommentPersonal from '../../json/modalDataCommentPersonal.json';
import dataCommentGroup from '../../json/modalDataCommentGroup.json';
import dataSpeech from '../../json/modalDataSpeech.json';
import dataAwards from '../../json/modalDataAwards.json';

export function modal() {
  const body = document.querySelector("body"); // 背景固定用に使用　付与されるis-fixedがbodyに付きます。検証してもらうと内容わかります。
  const modal = document.querySelector(".js-modal"); // 実際に表示させるモーダルのdiv
  const modalTrigger = document.querySelectorAll(".js-modalTrigger"); // 選択したい各動画
  const modalOverlay = document.querySelector(".js-modalOverlay"); // モーダル表示した際の黒透過背景用
  const modalClose = document.querySelector(".js-modalClose"); // モーダルを閉じるボタン
  const modalTtl = document.querySelector(".js-modalTtl"); 
  const modalTxt = document.querySelector(".js-modalTxt"); 
  const modalAuthor = document.querySelector(".js-modalAuthor"); 
  const modalLink = document.querySelector(".js-modalLink"); 

  // modal open
  const triggerList = Array.prototype.slice.call(modalTrigger, 0);

  triggerList.forEach((targetBox) => {
    targetBox.addEventListener("click", (e) => {

      body.classList.add("is-fixed"); // bodyにclassを付与して背景固定
      modalOverlay.classList.add("is-active"); // 背景に黒透過を表示
      modal.classList.add("is-active"); // モーダルを表示

      let dataType = targetBox.dataset.modaltype;

      if(dataType === "speech") {
        // console.log('speech');

        let triggerType = Number(targetBox.dataset.modalcont) - 1;
        modalTtl.innerHTML = dataSpeech[triggerType].title;
        modalTxt.innerHTML = dataSpeech[triggerType].content;
        modalAuthor.innerHTML = dataSpeech[triggerType].author;
        
        modalLink.style.display = "none";
        modalAuthor.style.display = "block";

      } else if (dataType === "commentGroup" || dataType === "commentPersonal") {
        // console.log('comment');

        let triggerType = targetBox.dataset.modalmatch;
        let theData;

        if(dataType === "commentGroup") {
          theData = dataCommentGroup.find((item)=>{
            return item.title === triggerType;
          })
        } else {
          theData = dataCommentPersonal.find((item)=>{
            return item.title === triggerType;
          })
        }

        modalTtl.innerHTML = theData.title;
        modalTxt.innerHTML = theData.content;
        
        if(theData.author) {
          modalAuthor.style.display = "block";
          modalAuthor.innerHTML = theData.author;
        } else {
          modalAuthor.style.display = "none";
        }

        if(theData.link) {
          modalLink.style.display = "block";
          modalLink.href = theData.link;
        } else {
          modalLink.style.display = "none";
        }

      } else if (dataType === "awards") {
        // console.log('awards');

        let triggerType = Number(targetBox.dataset.modalcont) - 1;
        modalTtl.innerHTML = dataAwards[triggerType].title;
        modalTxt.innerHTML = dataAwards[triggerType].content;

        modalLink.style.display = "none";
        modalAuthor.style.display = "none";
      }
      
    });
  });

  // modal close
  modalClose.addEventListener("click", () => {
    body.classList.remove("is-fixed");
    modalOverlay.classList.remove("is-active");
    modal.classList.remove("is-active");
  });

}